import { Avatar } from "antd";
import "./avatar.scss"
export default Avatar;
